import React from "react";

export const LineChart13 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={28} height={28} rx={1} fill="#F1F2F6" />

    <polyline
      points="2 21 7 8 10 18 16 11 20 15 26 9"
      fill="none"
      stroke="#0787C9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </g>
);
